import * as api from '../../services/user'

export const FETCH_USER_ADDRESSES = 'FETCH_USER_ADDRESSES';
export const FETCH_USER_ADDRESS = 'FETCH_USER_ADDRESS';




export const fetchUserAddress = (userId, addressId) => ({
    type: FETCH_USER_ADDRESS,
    payload: {
        promise: api.findUserAddress({userId: userId, addressId: addressId})
    }
});


export const fetchUserAddresses = (params) => {
    return {
        type: FETCH_USER_ADDRESSES,
        payload: {
            promise: api.findUserAddresses(params)
        }
    }
};



// WEBPACK FOOTER //
// ./src/redux/actions/userAddress.js